import {
  ADD_FORM,
  ADD_FORM_ERROR,
  ADD_FORM_SUCCESS,
  CHANGE_STEP,
  DELETE_FORM,
  DELETE_FORM_ERROR,
  DELETE_FORM_SUCCESS,
  FETCH_FORM,
  FETCH_FORM_FAIL,
  FETCH_FORM_SUCCESS,
  FETCH_CHARGERS,
  FETCH_CHARGERS_FAIL,
  FETCH_CHARGERS_SUCCESS,
  FETCH_FORMS,
  FETCH_FORMS_FAIL,
  FETCH_FORMS_SUCCESS,
  UNSET_FORM,
  UPDATE_FORM,
  UPDATE_FORM_ERROR,
  UPDATE_FORM_SUCCESS,
  ASSIGN_CHARGER,
  ASSIGN_CHARGER_SUCCESS,
  ASSIGN_CHARGER_FAIL,
  CREATE_CHECKLIST,
  CREATE_CHECKLIST_SUCCESS,
  CREATE_CHECKLIST_FAIL,
  FETCH_FORMS_LIST,
  FETCH_FORMS_LIST_SUCCESS,
  FETCH_FORMS_LIST_FAIL,
  ASSIGN_TO_CONTRACTOR,
  ASSIGN_TO_CONTRACTOR_SUCCESS,
  ASSIGN_TO_CONTRACTOR_FAIL,
} from 'actions/formActions';
import { toast } from 'react-toastify';
import { REHYDRATE } from 'redux-persist/lib/constants';
import { failMessages, successMessages } from 'utils/constants/messages';

const initialState = {
  chargers: [],
  forms: [],
  form: null,
  currentStep: 0,
  loading: false,
  error: null,
  allFormsList: [],
  contractorData: {}
};

const FormReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REHYDRATE: {
      return {
        ...state,
        ...payload?.Forms,
        ...payload?.allFormsList,

      };
    }
    case CHANGE_STEP: {
      return { ...state, currentStep: payload };
    }
    case FETCH_CHARGERS:
    case FETCH_FORMS:
    case FETCH_FORM:
    case ASSIGN_CHARGER:
    case ADD_FORM:
    case UPDATE_FORM:
    case DELETE_FORM:
    case FETCH_FORMS_LIST:
    case CREATE_CHECKLIST:
    case ASSIGN_TO_CONTRACTOR: {
      return {
        ...state,
        loading: true,
      };
    }
    case FETCH_CHARGERS_SUCCESS: {
      return {
        ...state,
        chargers: payload,
        loading: false,
      };
    }
    case FETCH_FORMS_SUCCESS: {
      const { results, ...rest } = payload;
      return {
        ...state,
        forms: results,
        ...rest,
        loading: false,
      };
    }
    case FETCH_FORM_SUCCESS: {
      return {
        ...state,
        form: payload,
        currentStep: payload.status === 'draft' ? parseInt(payload.step) : 0,
        loading: false,
      };
    }
    case FETCH_FORMS_LIST_SUCCESS: {
      return {
        ...state,
        allFormsList: payload.data,
        loading: false,
      };
    }

    case ASSIGN_TO_CONTRACTOR_SUCCESS: {
      return {
        ...state,
        contractorData: payload.data,
        loading: false,
      };
    }
    case ASSIGN_CHARGER_SUCCESS: {
      return {
        ...state,
        chargers: state.chargers.filter((charger) => charger.charger_id !== payload.chargerId),
        loading: false,
      };
    }
    case ADD_FORM_SUCCESS:
    case UPDATE_FORM_SUCCESS: {
      return {
        ...state,
        form: payload,
        currentStep: parseInt(payload.step),
        loading: false,
      };
    }
    case DELETE_FORM_SUCCESS: {
      toast.success(successMessages.deleteForm);
      return {
        ...state,
        forms: state.forms.filter((form) => form.id !== payload),
        loading: false,
      };
    }
    case CREATE_CHECKLIST_SUCCESS: {
      toast.success(successMessages.default || 'Checklist created successfully');
      return {
        ...state,
        loading: false,
      };
    }
    case FETCH_CHARGERS_FAIL:
    case FETCH_FORMS_FAIL:
    case FETCH_FORM_FAIL:
    case ASSIGN_CHARGER_FAIL:
    case ADD_FORM_ERROR:
    case UPDATE_FORM_ERROR:
    case DELETE_FORM_ERROR:
    case FETCH_FORMS_LIST_FAIL:
    case CREATE_CHECKLIST_FAIL: 
    case ASSIGN_TO_CONTRACTOR_FAIL:
    {
      toast.error(failMessages.error);
      return {
        ...state,
        loading: false,
      };
    }
    case UNSET_FORM: {
      return {
        ...state,
        form: null,
        currentStep: 0,
        allFormsList: null
      };
    }
    default:
      return { ...state };
  }
};

export default FormReducer;
